export const NAV_PAGES = [
  { title: "Inicio", path: "/" },
  { title: "Estadísticas", path: "/estadisticas" },
  { title: "Cédulas de búsqueda", path: "/cedulas-de-busqueda" },
  { title: "Conoce más", path: "/conoce-mas" },
];
